import CTAButton from '../LandingPage/Common/CTAButton';

function BackModal({ updateModal, modalStatus }) {

    return (
        <div className={"modal-container " + modalStatus}>
            <div className="overlay" onClick={() => updateModal("")}></div>
            <div className="modal">
                <span className="close-btn" onClick={() => updateModal("")}><img src={process.env.PUBLIC_URL + "/images/icons/icon-close.svg"} alt="close" /></span>
                <h4>Are you sure you want to leave this page?</h4>
                <CTAButton link={process.env.REACT_APP_IWANTTFC_HOMEPAGE} text="Back to Homepage" />
                <span className="btn" onClick={() => updateModal("")}>Cancel</span>
            </div>
        </div>
    );
}

export default BackModal;